import { render, staticRenderFns } from "./InformationField.vue?vue&type=template&id=09dcdf06&scoped=true&"
import script from "./InformationField.vue?vue&type=script&lang=js&"
export * from "./InformationField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dcdf06",
  null
  
)

export default component.exports